export const userForm = {
  accessId: '',
  email: '',
  name: '',
  password: '',
  passwordConfirmation: '',
  role: '',
  additionalInformationAttributes: { instrumentation_url: '' }
};
